import { z } from 'zod'

export const COACHING_SHELL_EXPORT_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellExportResponseSchema = z.unknown()
export type CoachingShellExportResponse = z.infer<typeof coachingShellExportResponseSchema>
